import { CommonFeatureStates, EXPRESSIONS } from "../variables/expressions.js";
import { CUSTOMIZABLE_VALUES, generatedMapStyleJSON, getStyleIdExpressions, DEFAULT_STYLING, getDefaultValue, getFeatureStateStyleIdExpressions, } from "../variables/layerStylingValues.js";
/**
 * Deklarieren der Properties für die MapLayers.
 * Diese Funktion ist nur deshalb notwendig, weil die Farben innerhalb des Objekts nicht referenziert werden.
 * Soll heißen, wenn colors.variables.js sich ändert, ändern sich nicht die (eigentlich referenzierten) Farben hier! Außer man bespielt es erst wenn die Farben da sind!
 */
export const getIndoorGeoJSONProperties = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    // istGlas START
    // The styleIdExpression contains bools, but this expression is needed as int type.
    // so this time the StyleIdExpression will be modified, so it works like expected.
    const styleIdExpressionGlass = [];
    // console.log(
    //   "getStyleIdExpressions(generatedMapStyleJSON?.rooms.glass)",
    //   getStyleIdExpressions(generatedMapStyleJSON?.rooms.glass)
    // );
    getStyleIdExpressions(generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms.glass).forEach((entry) => {
        var _a, _b, _c;
        if (typeof entry == "boolean") {
            if (entry === true) {
                styleIdExpressionGlass.push(DEFAULT_STYLING.rooms.height.glassLow);
            }
            else {
                styleIdExpressionGlass.push((_c = getDefaultValue((_b = (_a = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms) === null || _a === void 0 ? void 0 : _a.polygons) === null || _b === void 0 ? void 0 : _b.heights)) !== null && _c !== void 0 ? _c : DEFAULT_STYLING.rooms.height.standard);
            }
        }
        else {
            styleIdExpressionGlass.push(entry);
        }
    });
    // istGlas END
    return {
        rooms: {
            height: [
                "case",
                ...getFeatureStateStyleIdExpressions(CommonFeatureStates.height, generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms.polygons.heights_active),
                // if height is explicitly given it will overwrite class/type values in that feature
                EXPRESSIONS.roomType.hasHeight,
                EXPRESSIONS.roomType.getHeight,
                // wenn ein Raum glass ist, dann hat er immer einen niedrigen Boden
                // (außer height wurde explizit mitgegeben)
                // istGlas START
                // ...styleIdExpressionGlass,
                // istGlas END
                EXPRESSIONS.roomType.glass,
                DEFAULT_STYLING.rooms.height.glassLow,
                ...getStyleIdExpressions(generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms.polygons.heights),
                EXPRESSIONS.roomType.entranceRoom,
                DEFAULT_STYLING.rooms.height.entranceRoom,
                // rooms ohne glass
                // -- areas ---
                EXPRESSIONS.roomType.waitingArea,
                DEFAULT_STYLING.rooms.height.waitingArea,
                EXPRESSIONS.roomType.emergencyArea,
                DEFAULT_STYLING.rooms.height.emergencyArea,
                EXPRESSIONS.roomType.cafeteriaArea,
                DEFAULT_STYLING.rooms.height.cafeteriaArea,
                EXPRESSIONS.roomType.officeArea,
                DEFAULT_STYLING.rooms.height.officeArea,
                // --- rooms ---
                EXPRESSIONS.roomType.emergencyRoom,
                DEFAULT_STYLING.rooms.height.emergencyRoom,
                EXPRESSIONS.roomType.cafeteriaRoom,
                DEFAULT_STYLING.rooms.height.cafeteriaRoom,
                EXPRESSIONS.roomType.waitingRoom,
                DEFAULT_STYLING.rooms.height.waitingRoom,
                EXPRESSIONS.roomType.switchFloorRoom,
                DEFAULT_STYLING.rooms.height.switchFloorRoom,
                EXPRESSIONS.roomType.stairsRoom,
                DEFAULT_STYLING.rooms.height.stairsRoom,
                EXPRESSIONS.roomType.elevatorRoom,
                DEFAULT_STYLING.rooms.height.elevatorRoom,
                EXPRESSIONS.roomType.standardRoom,
                DEFAULT_STYLING.rooms.height.standard,
                // -- floors ---
                EXPRESSIONS.roomType.mainFloor,
                DEFAULT_STYLING.rooms.height.mainFloor,
                EXPRESSIONS.roomType.sideFloor,
                DEFAULT_STYLING.rooms.height.sideFloor,
                (_c = getDefaultValue((_b = (_a = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms) === null || _a === void 0 ? void 0 : _a.polygons) === null || _b === void 0 ? void 0 : _b.heights)) !== null && _c !== void 0 ? _c : DEFAULT_STYLING.rooms.height.standard,
            ],
            // made better somehow
            glassHeight: [
                "case",
                // wenn explizit eine height angegeben ist, dann muss diese genommen werden
                EXPRESSIONS.roomType.hasHeight,
                EXPRESSIONS.roomType.getHeight,
                ...getFeatureStateStyleIdExpressions(CommonFeatureStates.height, generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms.polygons.heights_active),
                ...getStyleIdExpressions(generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms.polygons.heights),
                (_f = getDefaultValue((_e = (_d = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms) === null || _d === void 0 ? void 0 : _d.polygons) === null || _e === void 0 ? void 0 : _e.heights)) !== null && _f !== void 0 ? _f : DEFAULT_STYLING.rooms.height.standard,
            ],
            base: [
                "case",
                ...getFeatureStateStyleIdExpressions(CommonFeatureStates.base, (_h = (_g = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms) === null || _g === void 0 ? void 0 : _g.polygons) === null || _h === void 0 ? void 0 : _h.bases_active),
                ...getStyleIdExpressions((_k = (_j = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms) === null || _j === void 0 ? void 0 : _j.polygons) === null || _k === void 0 ? void 0 : _k.bases),
                EXPRESSIONS.roomType.entranceRoom,
                DEFAULT_STYLING.rooms.base.entranceRoom,
                (_o = getDefaultValue((_m = (_l = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms) === null || _l === void 0 ? void 0 : _l.polygons) === null || _m === void 0 ? void 0 : _m.bases)) !== null && _o !== void 0 ? _o : 0,
            ],
            opacity: [
                "case",
                EXPRESSIONS.roomType.switchFloorRoom,
                DEFAULT_STYLING.rooms.opacity.switchFloorRoom,
                EXPRESSIONS.roomType.mainFloor,
                DEFAULT_STYLING.rooms.opacity.mainFloor,
                EXPRESSIONS.roomType.stairsRoom,
                DEFAULT_STYLING.rooms.opacity.stairsRoom,
                EXPRESSIONS.roomType.waitingRoom,
                DEFAULT_STYLING.rooms.opacity.waitingRoom,
                DEFAULT_STYLING.rooms.opacity.standardRoom,
            ],
            color: [
                "case",
                // custom highlight color, picked directly from state
                ...getFeatureStateStyleIdExpressions(CommonFeatureStates.fillColor, generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms.polygons.colors_active),
                // custom classes
                ...getStyleIdExpressions(generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms.polygons.colors),
                /** @deprecated highlight colors */
                EXPRESSIONS.roomType.highlight.standard,
                CUSTOMIZABLE_VALUES.highlight.standard,
                EXPRESSIONS.roomType.highlight.danger,
                CUSTOMIZABLE_VALUES.highlight.danger,
                EXPRESSIONS.roomType.highlight.warning,
                CUSTOMIZABLE_VALUES.highlight.warning,
                /** @deprecated legacy coloring, has to go later, because everything is now dependent on styleId */
                // floors
                EXPRESSIONS.roomType.mainFloor,
                CUSTOMIZABLE_VALUES.mainFloor,
                EXPRESSIONS.roomType.sideFloor,
                CUSTOMIZABLE_VALUES.sideFloor,
                EXPRESSIONS.roomType.restrictedFloor,
                CUSTOMIZABLE_VALUES.restrictedFloor,
                // rooms
                EXPRESSIONS.roomType.emergencyRoom,
                CUSTOMIZABLE_VALUES.emergencyRoom,
                EXPRESSIONS.roomType.cafeteriaRoom,
                CUSTOMIZABLE_VALUES.cafeteriaRoom,
                EXPRESSIONS.roomType.exit,
                CUSTOMIZABLE_VALUES.exit,
                EXPRESSIONS.roomType.switchFloorRoom,
                CUSTOMIZABLE_VALUES.levelRoom,
                EXPRESSIONS.roomType.elevatorRoom,
                CUSTOMIZABLE_VALUES.elevatorRoom,
                EXPRESSIONS.roomType.stairsRoom,
                CUSTOMIZABLE_VALUES.stairsRoom,
                EXPRESSIONS.roomType.waitingRoom,
                CUSTOMIZABLE_VALUES.waitingRoom,
                EXPRESSIONS.roomType.wcRoom,
                CUSTOMIZABLE_VALUES.wcRoom,
                EXPRESSIONS.roomType.entranceRoom,
                CUSTOMIZABLE_VALUES.entranceRoom,
                // areas
                EXPRESSIONS.roomType.emergencyArea,
                CUSTOMIZABLE_VALUES.emergencyArea,
                EXPRESSIONS.roomType.cafeteriaArea,
                CUSTOMIZABLE_VALUES.cafeteriaArea,
                EXPRESSIONS.roomType.waitingArea,
                CUSTOMIZABLE_VALUES.waitingArea,
                EXPRESSIONS.roomType.officeArea,
                CUSTOMIZABLE_VALUES.officeArea,
                // fallback value from styleId
                (_r = getDefaultValue((_q = (_p = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.rooms) === null || _p === void 0 ? void 0 : _p.polygons) === null || _q === void 0 ? void 0 : _q.colors)) !== null && _r !== void 0 ? _r : CUSTOMIZABLE_VALUES.rooms,
            ],
        },
        floors: {
            color: [
                "case",
                // custom highlight color, picked directly from state
                ...getFeatureStateStyleIdExpressions(CommonFeatureStates.fillColor, (_s = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.outlines) === null || _s === void 0 ? void 0 : _s.colors_active),
                // custom from database
                ...getStyleIdExpressions((_t = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.outlines) === null || _t === void 0 ? void 0 : _t.colors),
                // fallback
                (_v = getDefaultValue((_u = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.outlines) === null || _u === void 0 ? void 0 : _u.colors)) !== null && _v !== void 0 ? _v : CUSTOMIZABLE_VALUES.outline,
            ],
        },
        ground: {
            color: [
                "case",
                // custom highlight color, picked directly from state
                ...getFeatureStateStyleIdExpressions(CommonFeatureStates.fillColor, (_w = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.grounds) === null || _w === void 0 ? void 0 : _w.colors_active),
                // styled class expressions
                ...getStyleIdExpressions((_x = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.grounds) === null || _x === void 0 ? void 0 : _x.colors),
                // fallback
                (_z = getDefaultValue((_y = generatedMapStyleJSON === null || generatedMapStyleJSON === void 0 ? void 0 : generatedMapStyleJSON.grounds) === null || _y === void 0 ? void 0 : _y.colors)) !== null && _z !== void 0 ? _z : CUSTOMIZABLE_VALUES.ground,
            ],
        },
    };
};
